import { useStore } from "vuex";
import { computed, onMounted } from "vue";
import { isMobile } from "@/utils/devices";
import appConfig from "@/config";
export default {
  name: 'App',

  setup() {
    const store = useStore();
    const theme = computed(() => {
      return store.theme;
    });
    onMounted(() => {
      if (!isMobile() && appConfig.pcAdapter) {
        location.href = appConfig.cpsPcUrl;
      }
    });
    return {
      theme
    };
  }

};